import {setUser} from './reducers';

const defaultState = {
    user: null
};

function userReducers(state = defaultState, action) {
    return {
        user: setUser(state.user, action),
    }
}
export default userReducers;
